export default __webpack_public_path__ + "static/media/kako_funkcionisu_3.1a309353.png";